export default __webpack_public_path__ + "static/media/chamber-bg-landscape.1d549f33.png";